import defineService from './defineService';
const postSignup = defineService('post', 'api/v1/cta/signup/');

/**
 * User has entered their email. Post to back end which should trigger an
 * email to user, etc.
 *
 * This returns new token / user details. Since we now know new information
 * about the user, that gets updated on the user. currently the user becomes
 * a "real" user.
 *
 * @param {String} email
 * @returns {TokenAndUser}
 */
export async function emailSignUp(email) {
  return postSignup({email});
}




// WEBPACK FOOTER //
// ./src/services/cta.js